import { render, staticRenderFns } from "./ContentTopic.vue?vue&type=template&id=6d00a683"
import script from "./ContentTopic.vue?vue&type=script&lang=js"
export * from "./ContentTopic.vue?vue&type=script&lang=js"
import style0 from "./ContentTopic.vue?vue&type=style&index=0&id=6d00a683&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports